<template>
	<div
		:class="[`spinner-color-${color} a-spinner`]"
        :style="`z-index: ${zIndex}; transform: scale(${scale}); margin: ${finalMargin}px`"
	>
		<div class="spinner-ring"></div>
		<div class="spinner-ring"></div>
		<div class="spinner-ring"></div>
		<div class="spinner-ring"></div>
		<div class="spinner-ring"></div>
		<div class="spinner-ring"></div>
		<div class="spinner-ring"></div>
		<div class="spinner-ring"></div>
		<div class="spinner-ring"></div>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	scale: {
		type: Number,
		default: 1,
	},
	zIndex: {
		type: Number,
		default: 1,
	},
	color: {
		type: String,
		default: 'tealDark',
	},
})
const finalMargin = computed(() => {
	let scaleModifier = 2.2;
	return ((150 / scaleModifier) - props.scale * 10) * -1;
})
</script>

<script>
	export default {
		name: 'AonSpinner'
	}
</script>

<style lang="scss">
.a-spinner  {
	$baseSize: 140px;
	height: 150px;
	width: 150px;

	padding: 2px;
	overflow: hidden;
	position: relative;
	object-fit: cover;

	.spinner-ring {
		position: absolute;
		border-radius: 50%;
		border: 2px solid transparent;
		animation: a-spinner-animation 1500ms cubic-bezier(0.680, -0.750, 0.265, 1.750) infinite forwards;
		margin: auto;
		bottom: 0;
		left: 0;
		right: 0;
		top: 0;
	}

	.spinner-ring {
		border-width: 4px;
	}

	.spinner-ring:nth-child(1) {
		height: calc(#{$baseSize} / 9 + 0.3 * #{$baseSize} / 9);
		width: calc(#{$baseSize} / 9 + 0.3 * #{$baseSize} / 9);
		animation-delay: calc(50ms * 1);
	}

	.spinner-ring:nth-child(2) {
		height: calc(#{$baseSize} / 9 + 1.1 * #{$baseSize} / 9);
		width: calc(#{$baseSize} / 9 + 1.1 * #{$baseSize} / 9);
		animation-delay: calc(50ms * 2);
	}

	.spinner-ring:nth-child(3) {
		height: calc(#{$baseSize} / 9 + 2 * #{$baseSize} / 9);
		width: calc(#{$baseSize} / 9 + 2 * #{$baseSize} / 9);
		animation-delay: calc(50ms * 3);
	}

	.spinner-ring:nth-child(4) {
		height: calc(#{$baseSize} / 9 + 2.9 * #{$baseSize} / 9);
		width: calc(#{$baseSize} / 9 + 2.9 * #{$baseSize} / 9);
		animation-delay: calc(50ms * 4);
	}

	.spinner-ring:nth-child(5) {
		height: calc(#{$baseSize} / 9 + 3.8 * #{$baseSize} / 9);
		width: calc(#{$baseSize} / 9 + 3.8 * #{$baseSize} / 9);
		animation-delay: calc(50ms * 5);
	}

	.spinner-ring:nth-child(6) {
		height: calc(#{$baseSize} / 9 + 4.8 * #{$baseSize} / 9);
		width: calc(#{$baseSize} / 9 + 4.8 * #{$baseSize} / 9);
		animation-delay: calc(50ms * 6);
	}

	.spinner-ring:nth-child(7) {
		height: calc(#{$baseSize} / 9 + 5.7 * #{$baseSize} / 9);
		width: calc(#{$baseSize} / 9 + 5.7 * #{$baseSize} / 9);
		animation-delay: calc(50ms * 7);
	}

	.spinner-ring:nth-child(8) {
		height: calc(#{$baseSize} / 9 + 6.6 * #{$baseSize} / 9);
		width: calc(#{$baseSize} / 9 + 6.6 * #{$baseSize} / 9);
		animation-delay: calc(50ms * 8);
	}

	.spinner-ring:nth-child(9) {
		height: calc(#{$baseSize} / 9 + 7.5 * #{$baseSize} / 9);
		width: calc(#{$baseSize} / 9 + 7.5 * #{$baseSize} / 9);
		animation-delay: calc(50ms * 9);
	}
}

.spinner-color-tealDark {
	.spinner-ring {
		border-top-color: $tealDark;
	}
}
.spinner-color-peacock {
	.spinner-ring {
		border-top-color: $peacock;
	}
}
.spinner-color-black {
	.spinner-ring {
		border-top-color: black;
	}
}
.spinner-color-white {
	.spinner-ring {
		border-top-color: white;
	}
}
.spinner-color-grey {
	.spinner-ring {
		border-top-color: $grey04;
	}
}

@keyframes a-spinner-animation {
	100% {
		transform: rotate( 360deg );
	}
}
</style>
